import { AxiosError, AxiosResponse } from 'axios'

const getResponseStatusCode = (res: unknown): number => {
  if (!res) {
    return 500
  }

  const response = res as AxiosError | AxiosResponse

  if ('status' in response && typeof response.status === 'number') {
    return response.status || 500
  }
  if ('response' in response) {
    return getResponseStatusCode(response.response)
  }
  if ('code' in response && typeof response.code === 'number') {
    return response.code || 500
  }

  return 500
}

export default getResponseStatusCode
